import { color } from '@starryui10/theme/color';
import React from 'react';

export const Document = () => {
    return (
        <svg role="presentation" fill="none" xmlns="http://www.w3.org/2000/svg" height="96px" width="96px" viewBox="0 0 96 96">
            <circle cx="48" cy="48" r="48" fill={color.Grey.G10} />
            <g filter="url(#documentGraphic_back)">
                <rect x="24.8906" y="33" width="35.7535" height="46.0461" rx="3" transform="rotate(-7.92717 24.8906 33)" fill={color.Blue.B20} />
                <rect
                    x="26.019"
                    y="33.8525"
                    width="33.7535"
                    height="44.0461"
                    rx="2"
                    transform="rotate(-7.92717 26.019 33.8525)"
                    stroke={color.Blue.B60}
                    strokeWidth="2"
                />
            </g>
            <g filter="url(#documentGraphic_front)">
                <path
                    d="M37.7558 65H67.8822C68.9929 65 69.8906 64.1558 69.8906 63.124V31.2313L59.8485 21.8512H37.7558C36.6451 21.8512 35.7473 22.6954 35.7473 23.7272V63.124C35.7473 64.1558 36.6451 65 37.7558 65Z"
                    fill="white"
                    stroke={color.Blue.B60}
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M59.8906 22V29.2C59.8906 30.19 60.7846 31 61.8906 31H69.8906L59.8906 22Z"
                    fill="white"
                    stroke={color.Blue.B60}
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <path d="M41.8906 32H54.8919" stroke={color.Blue.B60} strokeWidth="2" strokeLinecap="round" />
            <path d="M41.8906 60H54.8919" stroke={color.Blue.B60} strokeWidth="2" strokeLinecap="round" />
            <path d="M41.8906 53H64.6428" stroke={color.Blue.B60} strokeWidth="2" strokeLinecap="round" />
            <path d="M41.8906 46H64.6428" stroke={color.Blue.B60} strokeWidth="2" strokeLinecap="round" />
            <path d="M41.8906 39H64.6428" stroke={color.Blue.B60} strokeWidth="2" strokeLinecap="round" />
            <defs>
                <filter
                    id="documentGraphic_back"
                    x="20.2753"
                    y="25.4538"
                    width="50.9928"
                    height="59.7676"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="2.5" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.152941 0 0 0 0 0.156863 0 0 0 0 0.2 0 0 0 0.2 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                </filter>
                <filter
                    id="documentGraphic_front"
                    x="29.7473"
                    y="17.8512"
                    width="46.1434"
                    height="55.1488"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="2.5" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.152941 0 0 0 0 0.156863 0 0 0 0 0.2 0 0 0 0.2 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                </filter>
            </defs>
        </svg>
    );
};
